<ng-container *ngIf="{ listenForLargeScreen: listenForLargeScreen$ | async } as componentData">
  <ng-container *ngIf="isHomePage || componentData.listenForLargeScreen">
    <ng-container *ngIf="{ loggedIn: loggedIn$ | async } as comp">
      <header>
        <!-- <div class="maintenance-banner" id="maintenance-banner">
          <div class="banner-content">
            <span class="banner-text">
              RealtyBid will undergo scheduled maintenance on <strong>Thursday, May 8th from 7PM - 11PM Central</strong>. Services may be temporarily interrupted.
            </span>
          </div>
          <button class="banner-close" onclick="document.getElementById('maintenance-banner').style.display='none'">x</button>
        </div> -->
        <nav class="nav">
          <a class="brand pl-2 me-3" [routerLink]="['/']">
            <img *ngIf="componentData.listenForLargeScreen" class="logo" src="./assets/images/realty-bid-logo-full.svg" alt="logo" />
            <img *ngIf="!componentData.listenForLargeScreen" class="logo" src="./assets/images/realty-bid-logo-sm.svg" alt="logo" />
          </a>
          <div class="nav-content">
            <app-nav class="nav-component" [isHomePage]="isHomePage"></app-nav>
          </div>
        </nav>
      </header>
    </ng-container>
  </ng-container>
</ng-container>
